!function ($) {

	"use strict";

	/**
	 * Program Object
	 */

	var Program = function (program) {
		this.programTable = $(program);

		this.init();
	};

	Program.prototype = {

		constructor: Program,

		init: function() {
			this.container = this.programTable.find('.program-container');
			this.content = this.container.find('.program-details');

			this.programTable.addClass('closed');

			this.isOpen = false;

			this.loadProgramDetailsUrl = '/programs/load-program-details';

			this.setId(this.programTable.data('id').replace(/^program/, ''))
				.registerListeners()
				.setContainerHeight(0)
				.addProgramNameContainer()
				.registerProgramNameListener()
				.createLoadingIndicator()
				.setCachedContent('')
				.setLoading(false);
		},

		registerListeners: function() {
			var that = this;

			this.programTable.find('.show-program').on('click', function(){
				that.showContainer();
				return false;
			});

			this.programTable.find('.hide-program').on('click', function(){
				that.hideContainer();
				return false;
			});

			/*
			this.programTable.closest('.program-table--link').click(function() {
				return false;
			});
			*/

			this.programTable.find('.program-table__header')
				.on('click', function () {
					if (that.isOpen) {
						that.hideContainer();
					}
					else {
						that.showContainer();
					}

					return false;
				});

			this.programTable.on('show.program', $.proxy(function () {
				this.loadContent();

				// Trigger the show event
				var onShowProgramEvent = $.Event('sportballOnShownProgram');
				onShowProgramEvent.programHtmlTable = this.programTable;

				$('body').trigger(onShowProgramEvent);
			}, this))
				.on('loaded.program', $.proxy(function () {

					this.registerProgramDetailsListener();

					this.createMapImage();

				}, this));

			return this;
		},

		registerProgramDetailsListener: function () {

			this.programTable.find('.program__register-button')
				.on('click', function (event) {

					$('.register-online-loading-screen').removeClass('is-visible');

					var loadingScreen = $($('#registerOnlineLoadingScreenTemplate').html());

					var programContainer = $(this).closest('.program-container');

					programContainer.find('.register-online-loading-screen')
						.remove();

					loadingScreen.appendTo(programContainer);

					programContainer.height();

					loadingScreen.addClass('is-visible');

				});

		},

		showContainer: function() {
			this.setContainerHeight('auto');

			this.isOpen = true;

			this.programTable.addClass('open').removeClass('closed').trigger('show.program');

			window.location.hash = 'program' + this.getId() + '@openSlider';
			
			return this;
		},

		hideContainer: function() {
			var that = this;

			this.isOpen = false;

			this.programTable.removeClass('open').trigger('hide.program');

			this.abortContentLoad();

			this.container.find('.program-details').one(transitionEndEvent(), function(){
				that.programTable.addClass('closed').trigger('hidden.program');
				that.setContainerHeight(0)
					.clearContent();
			}).triggerTransitionEndFallback();

			$('script[type="application/ld+json"][data-schema-type="program-schedules"]').remove();
			
			window.location.hash = '!';

			return this;
		},

		updateStructuredData: function() {
			$('script[type="application/ld+json"][data-schema-type="program-schedules"]').remove();
			
			var childrensEventData = this.content.find('.childrens-event');
			
			if (childrensEventData.length > 0) {
				
				var tdJsonScript = $('script[type="application/ld+json"]').last();

				var htmlScript = '<script type="application/ld+json" data-schema-type="program-schedules">';

				htmlScript += JSON.stringify({
					'@context': 'https://schema.org',
					'@type': 'ChildrensEvent',
					'name': childrensEventData.data('program-name'),
					'location': {
						'@type': 'Place',
						'name': childrensEventData.data('location-name'),
						'address': {
							'@type': 'PostalAddress',
							'addressLocality': childrensEventData.data('location-address-locality'),
							'addressRegion': childrensEventData.data('location-address-region'),
							'streetAddress': childrensEventData.data('location-street-address'),
							'postalCode': childrensEventData.data('location-address-postal-code')
						},
						'geo': {
							'@type': 'GeoCoordinates',
							'latitude': childrensEventData.data('location-latitude'),
							'longitude': childrensEventData.data('location-longitude')
						}
					},
					'eventStatus': {
						'@type': 'EventStatusType',
						'name': childrensEventData.data('event-status')
					},
					'description': childrensEventData.data('program-description'),
					'duration': childrensEventData.data('program-duration'),
					'startDate': childrensEventData.data('program-start-date'),
					'endDate': childrensEventData.data('program-end-date'),
					'url': window.location.href,
					'offers': {
						'@type': 'Offer',
						'price': childrensEventData.data('event-price'),
						'priceCurrency': window.appConfig.currentCurrency,
						'url': window.location.href
					},
					'performer': window.sportballStructuredData,
					'image': window.appConfig.websiteLogo
				});
				
				htmlScript += '</scr';

				htmlScript += 'ipt>';

				tdJsonScript.after(htmlScript);
			}
		},
		
		setContainerHeight: function(height) {
			this.container.css({
				'height': height
			});

			return this;
		},

		addProgramNameContainer: function() {
			this.programTable.find('.program-table__header--default .col-program').wrapInner('<div class="schedule-table-program-name"></div>');

			return this;
		},

		registerProgramNameListener: function() {
			this.programTable.find('.schedule-table-program-name')
				.on('mouseenter', function(){

					var originalWidth = $(this).width();

					$(this).wrapInner('<div class="hold" style="position:absolute"/>');

					var holdContainer = $(this).find('.hold');
					var openWidth = holdContainer.width();
					var programName = holdContainer.text();

					$(this).html(programName).removeAttr('style');

					if (originalWidth < openWidth) {
						$(this).addClass('open');
					}
				})

				.on('mouseleave', function(){
					$(this).removeClass('open');
				});

			return this;
		},

		createMapImage: function () {
			if (typeof this.mapImage === 'undefined') {
				var src = '//maps.googleapis.com/maps/api/staticmap?center=__latitude__,__longitude__&zoom=15&size=150x175&maptype=roadmap&markers=icon:__icon__|__latitude__,__longitude__&sensor=false';

				src = src
					.replace(/__latitude__/g, this.getLatitude())
					.replace(/__longitude__/g, this.getLongitude())
					.replace('__icon__', window.appConfig.websiteBaseUrlWithoutLanguage + '/app/themes/sportball-v3/assets/img/map-pin.png');

				this.mapImage = $('<img>').attr({
					'src': src,
					'class': 'program-location__map'
				});

				var mapLink = this.programTable.find('.program-location__map-link');
				mapLink.prepend(this.mapImage);
				mapLink.attr('href', mapLink.closest('.schedule-table').prev('.schedules__location-name').attr('href'));

				this.mapImage.on('load', function () {
					$(this).addClass('loaded');
				});
			}

			return this;
		},

		loadContent: function () {
			var that = this;

			if (this.isLoading()) {
				return this;
			}

			if (this.getCachedContent()) {
				this.content.html(this.getCachedContent());
				
				this.updateStructuredData();
			}
			else {
				this.programTable.trigger('loading.program').addClass('loading');

				this.setLoading(true);

				this.contentLoadAjaxHandler = $.ajax({
					url: this.getLoadProgramDetailsUrl(),
					type: 'POST',
					dataType: 'html',
					data: {
						programId: this.getId()
					},
					complete: function() {
						that.programTable.removeClass('loading');
						that.setLoading(false);
						that.updateStructuredData();
					},
					success: function (data) {
						that.content.html(data);
						that.programTable.trigger('loaded.program');
					},
					error: function () {
						that.programTable.trigger('error.program');

						var retryLink = $('<a href="#">' + window.translator.translate('reload info.') + '</a>');

						var errorMessage = $('<div class="error-message">' + window.translator.translate('Problem loading program info,') + ' </div>').append(retryLink);

						var errorMessageContainer = $('<div class="error-message-container"/>').append(errorMessage);

						that.content.parent().append(errorMessageContainer);

						retryLink.one('click.program', function () {
							errorMessageContainer.remove();
							that.loadContent();
							return false;
						});

						that.programTable.one('hide.program', function () {
							errorMessageContainer.remove();
						});
					}
				});
			}

			return this;
		},

		abortContentLoad: function () {
			if (typeof this.contentLoadAjaxHandler != 'undefined') {
				this.contentLoadAjaxHandler.abort();
			}

			return this;
		},

		clearContent: function () {
			this.setCachedContent(this.content.html());

			this.content.html('');

			return this;
		},

		createLoadingIndicator: function () {
			this.loadingIndicator = $('<i class="loading-indicator-container"><i class="loading-indicator"></i></i>');
			this.loadingIndicator.insertBefore(this.content);
			return this;
		},

		setId: function (id) {
			this.id = id;

			return this;
		},

		getId: function () {
			return this.id;
		},

		getLatitude: function () {
			return this.programTable.find('.program-location').data('latitude');
		},

		getLongitude: function () {
			return this.programTable.find('.program-location').data('longitude');
		},

		getLoadProgramDetailsUrl: function () {
			return window.appConfig.websiteBaseUrlWithoutLanguage + this.loadProgramDetailsUrl;
		},

		getCachedContent: function () {
			return this.cachedContent;
		},

		setCachedContent: function (content) {
			this.cachedContent = content;
			return this;
		},

		setLoading: function (state) {
			this.loadingState = Boolean(state);
			return this;
		},

		isLoading: function () {
			return this.loadingState;
		}
	};

	/**
	 * ScheduleTable Object
	 */
	var ScheduleTable = function (scheduleTable) {
		this.table = $(scheduleTable);
		this.programs = this.table.find('table');

		this.init();
	};

	ScheduleTable.prototype = {

		constructor: ScheduleTable,

		init: function () {
			this.programs.each(function() {
				new Program(this);
			});
		}

	};

	$.fn.scheduleTable = function () {
		this.each(function () {
			new ScheduleTable($(this));
		});
	}

}(window.jQuery);
